import React, { forwardRef } from 'react';
import CustomTimeInput from './CustomTimeInput';
import { ClearButton } from 'shared/buttons';
import BaseLabel from '../../labels/BaseLabel';
import isNil from 'lodash/isNil';

/**
 * @typedef {React.ComponentPropsWithoutRef<CustomTimeInput>} CustomTimeInputProps
 *
 * @param {CustomTimeInputProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BaseTimeInput = ({ width, label, ...props }, ref) => {
  const { onChange } = props;
  const onClear = () => onChange({ value: null });
  return (
    <span className='k-widget k-timeinput base-time-input' {...(!isNil(width) ? { style: { width } } : {})}>
      {label && <BaseLabel editorRef={ref}>{label}</BaseLabel>}
      <span className='k-timeinput-wrap'>
        <CustomTimeInput ref={ref} {...props} />
        <ClearButton onClick={onClear} tabIndex={-1} />
      </span>
    </span>
  );
};

/**
 * A base time input component.
 *
 * @param {CustomTimeInputProps} props Component props. Extends CustomTimeInputProps props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base time input component.
 */
const ForwardTimeInput = forwardRef(BaseTimeInput);

export default ForwardTimeInput;
